<div class="modal-body">
    <cm-entry-header [step]="step"></cm-entry-header>
    <cm-step-on-behalf-list
        *ngIf="step.on_behalf_indicator"
        [onBehalfIndicator]="step.on_behalf_indicator"
    ></cm-step-on-behalf-list>
    <div class="step-section" *ngIf="showInvitationForm">
        <h3 class="step-section-title">Invite your supervisor</h3>
        <div class="invitation-hint">
            <img
                class="invitation-hint__icon"
                src="/assets/images/professional/supervisor/supervisor.png"
                srcset="
                    /assets/images/professional/supervisor/supervisor.png    1x,
                    /assets/images/professional/supervisor/supervisor@2x.png 2x,
                    /assets/images/professional/supervisor/supervisor@3x.png 3x
                "
                alt="Supervisor icon"
            />
            <p class="invitation-hint__text">
                Your supervisor should complete the form above in order to complete the step. Please invite your
                supervisor by filling in the following form.
            </p>
        </div>
        <form [formGroup]="invitationForm" class="invitation-form" autocomplete="off">
            <div class="form-group">
                <label for="first_name" class="form-label required">First name</label>
                <input
                    id="first_name"
                    formControlName="first_name"
                    class="form-control ch-input"
                    [ngClass]="{ error: showErrors && invitationForm.controls.first_name.invalid }"
                />
            </div>
            <div class="form-group">
                <label for="last_name" class="form-label required">Last name</label>
                <input
                    id="last_name"
                    formControlName="last_name"
                    class="form-control ch-input"
                    [ngClass]="{ error: showErrors && invitationForm.controls.last_name.invalid }"
                />
            </div>
            <div class="form-group">
                <label for="email" class="form-label required">Email</label>
                <input
                    type="email"
                    id="email"
                    formControlName="email"
                    class="form-control ch-input"
                    [ngClass]="{ error: showErrors && invitationForm.controls.email.invalid }"
                />
            </div>
            <div class="form-group">
                <label for="invitation_message" class="form-label">Invitation text</label>
                <textarea
                    id="invitation_message"
                    formControlName="invitation_message"
                    class="form-control"
                    placeholder="{{ defaultInvitationMessagePlaceholder }}"
                ></textarea>
            </div>
        </form>
        <div *ngIf="showErrors && validationMessage" class="errors">
            <p class="error">{{ validationMessage }}</p>
        </div>
    </div>
    <div class="step-section">
        <h3 class="step-section-title">Supervisor form</h3>
        <cm-dynamic-form
            [elements]="step.log_form.fields"
            [disabled]="true"
            [sections]="step.log_form.sections"
        ></cm-dynamic-form>
    </div>
    <div class="step-section" *ngIf="step.content.supervisors?.length">
        <h3 class="step-section-title">Supervisor</h3>
        <div class="supervisor" *ngFor="let supervisor of step.content.supervisors">
            <img
                class="supervisor__icon"
                src="/assets/images/professional/supervisor/supervisor.png"
                srcset="
                    /assets/images/professional/supervisor/supervisor.png    1x,
                    /assets/images/professional/supervisor/supervisor@2x.png 2x,
                    /assets/images/professional/supervisor/supervisor@3x.png 3x
                "
                alt="Supervisor icon"
            />
            <div class="supervisor__info">
                <p class="supervisor__name">{{ supervisor.first_name }} {{ supervisor.last_name }}</p>
                <p class="supervisor__email">{{ supervisor.email }}</p>
                <p class="supervisor__expiration" *ngIf="supervisor.status_id === STATUSES.PENDING">
                    Invitation expires: {{ supervisor.expiration_date | dateFormat }}
                </p>
                <p class="supervisor__status">{{ supervisor.status_id | status: 'supervisor' }}</p>
                <button
                    *ngIf="
                        supervisor.status_id === STATUSES.PENDING &&
                        !supervisor.resendControlsVisible &&
                        step.permissions.canResendInvitation
                    "
                    class="cm-link"
                    (click)="showResendControls(supervisor)"
                >
                    Resend invitation
                </button>
                <div *ngIf="supervisor.resendControlsVisible" class="resendInvite">
                    <p class="resendInvite__title required">Invitation to Supervisor expires on</p>
                    <cm-datepicker
                        class="ch-datepicker"
                        [(ngModel)]="supervisor.expiration_date"
                        [minDate]="datePickerMinDate"
                        [maxDate]="datePickerMaxDate"
                    >
                    </cm-datepicker>
                    <button class="btn btn-primary" type="button" (click)="resendInvitation(supervisor)">Resend</button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="checkFormChanges()">CLOSE</button>
    <button
        type="button"
        class="btn btn-primary"
        [disabled]="step._userActionsDisabled"
        *ngIf="!showInvitationForm && stepEditableStatus && step.content.can_invite_supervisors"
        (click)="showForm()"
    >
        INVITE SUPERVISOR
    </button>
    <button type="button" class="btn btn-primary" *ngIf="showInvitationForm" (click)="checkValidation()">
        SEND INVITATION
    </button>
</div>
